const aDayBDay = [false, "n A", " B", "n A", " B", "n A", false];
const d = new Date();
let block = aDayBDay[d.getDay()];

export default block;
